var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "12px"
    }
  }, [_vm._l(_vm.filteredPresets, function (item) {
    return _c('v-card', {
      key: item.value,
      staticClass: "d-flex justify-center align-center pa-3 pa-md-6 relative",
      class: {
        active: _vm.selected === item
      },
      style: {
        'background-color': item.skin.page_background_color || _vm.DEFAULT.page_background_color
      },
      attrs: {
        "hover": "",
        "disabled": _vm.disabled
      },
      on: {
        "click": function ($event) {
          _vm.$emit('input', Object.assign({}, _vm.order.skin, _vm.DEFAULT_THEME, item.skin, _vm.orgSkin || {}));
        }
      }
    }, [item.skin.open_effect ? _c('v-lazy', [_c('confetti', {
      staticClass: "absolute",
      staticStyle: {
        "z-index": "2",
        "left": "-50%",
        "top": "-50%",
        "width": "200%",
        "height": "200%",
        "transform": "scale(.5)"
      },
      attrs: {
        "effect": item.skin.open_effect,
        "active": true
      }
    })], 1) : _vm._e(), _c('v-card', {
      style: {
        'background-color': item.skin.env_background_color || _vm.DEFAULT.env_background_color,
        'color': item.skin.env_font_color || _vm.DEFAULT.env_font_color,
        'font-family': item.skin.env_font || _vm.DEFAULT.env_font,
        'font-size': _vm.fontSize
      },
      attrs: {
        "tile": "",
        "width": _vm.width
      }
    }, [_c('v-responsive', {
      attrs: {
        "aspect-ratio": 7 / 5
      }
    }, [_c('div', {
      staticClass: "fill-height d-flex justify-center align-center text-center"
    }, [_vm._v(" " + _vm._s(item.value) + " ")])])], 1)], 1);
  }), _vm.nHiddenPresets ? _c('div', {
    staticClass: "d-flex align-center text--label-active font-italic",
    staticStyle: {
      "min-width": "120px"
    }
  }, [_vm._v(" Your organization's custom branding is hiding " + _vm._s(_vm.nHiddenPresets) + " preset" + _vm._s(_vm.nHiddenPresets == 1 ? '' : 's') + " ")]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }